import { Locales } from '@/types/enums';
import { THeaderEnum } from '@/types/translations/enums';
import DE from '@/public/images/countries/DE.svg';
import FR from '@/public/images/countries/FR.svg';
import IT from '@/public/images/countries/IT.svg';
import EN from '@/public/images/countries/EN.svg';
import ES from '@/public/images/countries/ES.svg';

const localesArray = Object.values(Locales);

const localesWithIcons = {
  en: {
    icon: EN,
    tHeaderKey: THeaderEnum['locales.en'],
    tCommonKey: 'english',
    tFallback: 'English',
    locale: Locales.EN,
  },
  de: {
    icon: DE,
    tHeaderKey: THeaderEnum['locales.de'],
    tCommonKey: 'german',
    tFallback: 'German',
    locale: Locales.DE,
  },
  es: {
    icon: ES,
    tHeaderKey: THeaderEnum['locales.es'],
    tCommonKey: 'spanish',
    tFallback: 'Spanish',
    locale: Locales.ES,
  },
  it: {
    icon: IT,
    tHeaderKey: THeaderEnum['locales.it'],
    tCommonKey: 'italian',
    tFallback: 'Italian',
    locale: Locales.IT,
  },
  fr: {
    icon: FR,
    tHeaderKey: THeaderEnum['locales.fr'],
    tCommonKey: 'french',
    tFallback: 'French',
    locale: Locales.FR,
  },
};

const localesWithIconsArray = Object.values(localesWithIcons);

const changingLanguageMessage = {
  en: 'Changing language...',
  de: 'Sprache ändern...',
  es: 'Cambiando idioma...',
  it: 'Cambiando lingua...',
  fr: 'Changement de langue...',
};

const languageFloatingIconMessage = {
  en: 'We detect your language as {{languageKey}}. Do you want to change it?',
  de: 'Wir erkennen Ihre Sprache als {{languageKey}}. Möchten Sie sie ändern?',
  es: 'Detectamos tu idioma como {{languageKey}}. ¿Quieres cambiarlo?',
  it: 'Riconosciamo il tuo linguaggio come {{languageKey}}. Vuoi cambiarlo?',
  fr: 'Nous détectons votre langue comme {{languageKey}}. Voulez-vous la changer?',
};

const languageFloatingIconLabel = {
  en: {
    en: 'English',
    de: 'German',
    es: 'Spanish',
    it: 'Italian',
    fr: 'French',
  },
  de: {
    en: 'Englisch',
    de: 'Deutsch',
    es: 'Spanisch',
    it: 'Italienisch',
    fr: 'Französisch',
  },
  es: {
    en: 'Inglés',
    de: 'Alemán',
    es: 'Español',
    it: 'Italiano',
    fr: 'Francés',
  },
  it: {
    en: 'Inglese',
    de: 'Deutsch',
    es: 'Español',
    it: 'Italiano',
    fr: 'Francese',
  },
  fr: {
    en: 'Anglais',
    de: 'Deutsch',
    es: 'Español',
    it: 'Italiano',
    fr: 'Français',
  },
};

const languageConstants = {
  localesArray,
  localesWithIcons,
  changingLanguageMessage,
  localesWithIconsArray,
  languageFloatingIconMessage,
  languageFloatingIconLabel,
};

export default languageConstants;
